var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2.75H1.97222C1.64807 2.75 1.33719 2.89048 1.10798 3.14052C0.878769 3.39057 0.75 3.72971 0.75 4.08333V13.4167C0.75 13.7703 0.878769 14.1094 1.10798 14.3595C1.33719 14.6095 1.64807 14.75 1.97222 14.75H10.5278C10.8519 14.75 11.1628 14.6095 11.392 14.3595C11.6212 14.1094 11.75 13.7703 11.75 13.4167V8.75",
    stroke: "#BF4F18",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1856 1.18999C11.4673 0.908268 11.8494 0.75 12.2478 0.75C12.6462 0.75 13.0283 0.908268 13.31 1.18999C13.5917 1.47171 13.75 1.8538 13.75 2.25221C13.75 2.65062 13.5917 3.03272 13.31 3.31443L6.5826 10.0419L3.75 10.75L4.45815 7.9174L11.1856 1.18999Z",
    stroke: "#BF4F18",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.bf5a346fbfd8705e850a296a9b622031.svg";
export { ForwardRef as ReactComponent };